import {
    TOKENFCM_ERROR,
    TOKENFCM_LOADING,
    TOKENFCM_SUCCESS,
    TOKENFCM_RESET,
    RESET_PORTAL_CONTEXT,
    SET_NEW_TOKENFCM,
  } from "../ActionTypes";
  
  import tokenFCMInitialState from "../initialStates/tokenFCMInitialState";
  
  const tokenFCM = (state, { payload, type }) => {
    switch (type) {
      case TOKENFCM_LOADING:
        return {
          ...state,
          tokenFCM: {
            ...state.tokenFCM,
            error: false,
            loading: true,
          },
        };
      case TOKENFCM_SUCCESS:
        return {
          ...state,
          tokenFCM: {
            ...state.tokenFCM,
            loading: false,
            error: false,
            data: payload,
          },
        };
      case SET_NEW_TOKENFCM:
        return {
          ...state,
          tokenFCM: {
            ...state.tokenFCM,
            newToken: payload,
          },
        };
      case TOKENFCM_ERROR:
        return {
          ...state,
          tokenFCM: {
            ...state.tokenFCM,
            error: payload,
            loading: false,
          },
        };
  
      case TOKENFCM_RESET:
        return tokenFCMInitialState;
        
      case RESET_PORTAL_CONTEXT:
        return tokenFCMInitialState;
  
      default:
        return state;
    }
  };
  
  export default tokenFCM;